module.exports = __webpack_public_path__ + "img/8-solar-panel.c71d7e2e.svg";